import { schema, normalize } from 'normalizr';
import { createActions, asyncAction } from '../helpers/redux';
import { push } from 'react-router-redux';

const userSchema = new schema.Entity('users');
const basetimeZoneSchema = new schema.Entity('Time Zone');
const timeZoneSchema = new schema.Entity(
  'Time Zone',
  {
  },
  {
    idAttribute: timezone => {
      return `${timezone.id}`;
    },
  },
);
export const projectSchema = new schema.Entity('projects', {
  user: userSchema,
  props: {
    'Time Zone': {
      _value: timeZoneSchema,
    }
  }
});

const typeSchema = new schema.Entity('types');
const relationshipSchema = new schema.Entity('relationships');
const elementSchema = new schema.Entity('elements');
const tagSchema = new schema.Entity('tags');

const objectTagsSchema = new schema.Entity(
  'objectTags',
  {
    tag: tagSchema,
  },
  {
    idAttribute: tag => {
      return `${tag.taggable_id}-${tag.taggable_type}-${tag.tag_id}`;
    },
  },
);

elementSchema.define({
  type: typeSchema,
  objectTags: [objectTagsSchema],
  children: [elementSchema],
  relationships: [relationshipSchema],
});

// projectSchema.define({
//   user: userSchema
// });

export const ProjectActions = createActions({
  @asyncAction()
  async importJSONProject(project) {
    return ({ client }) => {
      const data = new FormData();
      data.append('file', project.file);
      data.append('name', project.name);
      data.append('type', 'sight');
      data.append('description', project.description);
      data.append('account_id', project.accountId);
      data.append('plan_id', project.planId);
      return client
        .post('/projects/import', {
          body: data,
          formData: true,
          //        headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(response => normalize(response, projectSchema));
    };
  },

  changeProducts(product) {
    return {
      product,
    }
  },

  suspendProject(projectId) {
    return ({ client, getState, dispatch }) => {
      return { projectId, isSuspended: true };
    };
  },

  unsuspendProject(projectId) {
    return ({ client, getState, dispatch }) => {
      return { projectId, isSuspended: false };
    };
  },

  @asyncAction()
  async changeUserRole(projectId, userId, roleId) {
    return async ({ client }) => {
      const response = await client.patch(
        `/projects/${projectId}/users/${userId}`,
        { body: { role_id: roleId } },
      );
      return response;
    };
  },

  @asyncAction()
  async getTimezones(projectId) {
    return async ({ client }) => {
      const response = await client.get(`/projects/${projectId}/timezones`);
      return normalize(response, [basetimeZoneSchema]);
    };
  },

  @asyncAction()
  async getIcons(projectId) {
    return async ({ client }) => {
      const response = await client.get(`/projects/${projectId}/icons`);
      return { icons: response };
    };
  },

  @asyncAction()
  async setIcon(projectId, componentType, componentId, iconId) {
    return async ({ dispatch, getState, client }) => {
      const response = await client.post(`/projects/${projectId}/icons`, {
        body: { componentType, componentId, iconId },
      });
      return { result: response };
    };
  },

  @asyncAction()
  async removeProjectUser(projectId, userId) {
    return async ({ client }) => {
      await client.delete(`/projects/${projectId}/users/${userId}`);
      return { projectId, userId };
    };
  },

  @asyncAction()
  async removePendingProjectUser(projectId, userId) {
    return async ({ client }) => {
      await client.delete(`/projects/${projectId}/pendingusers/${userId}`);
      return { projectId, userId };
    };
  },

  @asyncAction()
  async copyProject(projectId) {
    return async ({ client }) => {
      const response = await client.post('/projects/copy', {
        body: { id: projectId },
      });
      return normalize(response, projectSchema);
    };
  },

  @asyncAction()
  async getProjectMappings(projectId) {
    return async ({ client }) => {
      const response = await client.get(`/projects/${projectId}/mappings`);
      return response;
      // return normalize(response, [projectSchema]);
      // return client.get(`/accounts/${accountId}/projects`).then(function(response) {
      //   return normalize(response, [projectSchema]);
      // });
    };
  },

  @asyncAction()
  async getProjects(accountId) {
    return async ({ client }) => {
      const response = await client.get(`/accounts/${accountId}/projects`);
      return normalize(response, [projectSchema]);
      // return client.get(`/accounts/${accountId}/projects`).then(function(response) {
      //   return normalize(response, [projectSchema]);
      // });
    };
  },

  @asyncAction()
  async getProject(projectId) {
    return async ({ client, getState, dispatch }) => {
      const response = await client.get(`/projects/${projectId}`);
      return normalize(response, projectSchema);
    };
  },

  @asyncAction()
  async iconSearch(projectId, input, limit) {
    return async ({ client }) => {
      const response = await client.post(`/projects/${projectId}/iconSearch`, {
        body: { input, limit },
      });
      return response;
    };
  },

  clearIconSearch() {
    return {};
  },

  @asyncAction()
  async createProject(project) {
    return async ({ client }) => {
      const newProject = await client.post('/projects', { body: project });
      return normalize(newProject, projectSchema);
    };
  },

  @asyncAction()
  async renameProject(projectId, projectName) {
    return async ({ client }) => {
      const response = await client.patch(`/projects/${projectId}`, {
        body: { name: projectName },
      });
      return normalize(response, projectSchema);
    };
  },

  @asyncAction()
  async saveDescription(projectId, description) {
    return async ({ client }) => {
      const response = await client.patch(`/projects/${projectId}`, {
        body: { description },
      });
      return normalize(response, projectSchema);
    };
  },

  @asyncAction()
  async getRootElement(projectId) {
    return async ({ client }) => {
      const response = await client.get(`/projects/${projectId}/elements/root`);
      return normalize(response, elementSchema);
    };
  },

  resetReducers(userId) {
    return {
      userId,
    };
  },

  sortData(sortOn, sortType) {
    return { sortOn, sortType };
  },

  clearSearch(sortOn, sortType) {
    return { sortOn, sortType };
  },

  setCurrentProjectId(projectId) {
    return { projectId };
  },

  @asyncAction()
  async createCustomProperty(projectId, options) {
    return async ({ client }) => {
      const response = await client.post(`/projects/${projectId}`, {
        body: { props: options.props },
      });
      if (options.success) options.success();
      return { props: response, projectId };
    };
  },

  @asyncAction()
  async updateCustomProperty(projectId, options) {
    return async ({ client }) => {
      const response = await client.patch(`/projects/${projectId}/props`, {
        body: { props: options.props },
      });
      if (options.success) options.success();
      return { props: response, projectId };
    };
  },

  // @asyncAction()
  // async renameElementTypeMetaProperty(obj){
  //   return async ({client, getState, Checkit}) => {
  //     return client.patch(`/element_types/${obj.elementTypeId}/props/${obj.prop}/${obj.metaKey}/rename`, {
  //       body: obj
  //     }).then((response) => {
  //       let rsp = {};
  //       rsp.elementtype_id = obj.elementTypeId;
  //       rsp.prop = obj.prop;
  //       rsp.deleted_meta_key = obj.metaKey;
  //       rsp.new_meta_key = obj.newMetaKey;
  //       return rsp;
  //     });
  //   }
  // },

  @asyncAction()
  async renameProjectProperty(obj) {
    return async ({ client, getState, Checkit }) => {
      await client.patch(`/projects/${obj.projectId}/prop/${obj.prop}/rename`, {
        body: obj,
      });
      const rsp = {};
      rsp.projectId = obj.projectId;
      rsp.prop = obj.prop;
      rsp.newPropKey = obj.newPropKey;
      return rsp;
    };
  },

  @asyncAction()
  async deleteProjectProperty(obj) {
    return async ({ client, getState, Checkit }) => {
      await client.delete(`/projects/${obj.projectId}/prop/${obj.prop}`);
      const rsp = {};
      rsp.projectId = obj.projectId;
      rsp.prop = obj.prop;
      return rsp;
    };
  },

  @asyncAction()
  async deleteProject(projectId, accountId, userId, redirect = true) {
    return async ({ dispatch, client, getState, Checkit }) => {
      const response = await client.delete(`/projects/${projectId}`);
      response.id = projectId;
      if (redirect) {
        dispatch(push('/projects'));
      }
      return response;
    };
  },

  @asyncAction()
  async downloadExport(projectId, moduleId) {
    return async ({ client, getState, Checkit }) => {
      const response = await client.get(
        `/projects/${projectId}/export/${moduleId}`,
      );
      return response;
    };
  },
});



// WEBPACK FOOTER //
// ./src/actions/project.js